import {z} from 'zod';

import {FinancialProductMoneySchema} from './FinancialProductMoneySchema';
import {FinancialProductOfferSchema} from './FinancialProductOfferSchema';
import {FinancialProductTypeSchema} from './FinancialProductTypeSchema';

/** Actor identity and authenticated timestamp validation belong to the consuming adapter. */
export const FinancialProductsResponseBodyBaseSchema = z.object({
  mode: z.enum(['LIVE', 'CONTRACT_SNAPSHOT']),
  snapshotCapturedAt: z.string().nullable(),
  /** Pricing basis for every published amount; never derive it on the client. */
  vehiclePriceWithVat: FinancialProductMoneySchema.nullable(),
  selectedProduct: FinancialProductTypeSchema.nullable(),
  preferenceRevision: z.number(),
  preferenceUpdatedAt: z.string().nullable(),
  standard: FinancialProductOfferSchema.nullable(),
  balloon: FinancialProductOfferSchema.nullable(),
  leasing: FinancialProductOfferSchema.nullable(),
});
export type FinancialProductsResponseBodyBase = z.infer<
  typeof FinancialProductsResponseBodyBaseSchema
>;
